"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RxIcon = void 0;
const react_1 = require("react");
const React = require("react");
const icon_1 = require("./icon");
class RxIcon extends react_1.Component {
    render() {
        const { fill = icon_1.ICON_COLORS.fill } = this.props;
        return (React.createElement("svg", { width: "24px", height: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("g", { stroke: "none", strokeWidth: "1", fill: fill, fillRule: "evenodd" },
                React.createElement("g", { fill: fill },
                    React.createElement("path", { d: "M13.9032636,17.3782574 L12.2975779,19 L8.85813149,19 L12.3672634,15.6164933 L9.16493656,11.9434833 L8.29296424,11.9434833 L8.29296424,15.7704729 L6,15.7704729 L6,5 L11.0380623,5 C13.2825836,5 14.6551326,6.46943483 14.6551326,8.47174164 C14.6551326,10.3771626 13.4602076,11.3944637 12.2975779,11.6689735 L14.210073,13.8396554 L15.6239908,12.4763552 L18.7566321,12.4763552 L15.7153058,15.5480947 L18.7566321,19 L15.3171857,19 L13.9032636,17.3782574 Z M10.6989619,9.92502884 C11.6193772,9.92502884 12.3137255,9.37600923 12.3137255,8.47174164 C12.3137255,7.56747405 11.6193772,7.01845444 10.6989619,7.01845444 L8.29296424,7.01845444 L8.29296424,9.92502884 L10.6989619,9.92502884 Z" })))));
    }
}
exports.RxIcon = RxIcon;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/rx.tsx
// module id = 2162
// module chunks = 0 1 2